<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('银行支行.联行号')">
                <a-input v-model="queryParam.code" :placeholder="$t('银行支行.请输入联行号')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('银行支行.银行全名')">
                <a-input v-model="queryParam.name" :placeholder="$t('银行支行.请输入银行全名')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('银行支行.银行简称')">
                <a-input v-model="queryParam.bankAlias" :placeholder="$t('银行支行.请输入银行简称')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('银行支行.银行名称')">
                <a-input v-model="queryParam.bankName" :placeholder="$t('银行支行.请输入银行名称')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('银行支行.银行编码')">
                <a-input v-model="queryParam.bankCode" :placeholder="$t('银行支行.请输入银行编码')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('银行支行.城市名称')">
                <a-input v-model="queryParam.cityName" :placeholder="$t('银行支行.请输入城市名称')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('银行支行.省份名称')">
                <a-select v-model="queryParam.provinceName" :placeholder="$t('银行支行.请选择省份名称')" allow-clear>
                  <a-select-option v-for="(item, index) in provinceDict" :key="index" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('银行支行.图标')">
                <a-select v-model="queryParam.bankIcon" :placeholder="$t('银行支行.请选择图标')" allow-clear>
                  <a-select-option v-for="(item, index) in bankIconDict" :key="index" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('通用.按钮.查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('通用.按钮.重置') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 操作按钮 -->
      <div class="table-operations">
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['bank:bankBranch:remove']">
          <a-icon type="delete" />{{ $t('通用.按钮.删除') }}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['bank:bankBranch:export']">
          <a-icon type="download" />{{ $t('通用.按钮.导出') }}
        </a-button>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record)" v-hasPermi="['bank:bankBranch:edit']">
            <a-icon type="edit" />{{ $t('通用.按钮.修改') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['bank:bankBranch:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['bank:bankBranch:remove']">
            <a-icon type="delete" />{{ $t('通用.按钮.删除') }}
          </a>
        </span>
      </a-table>

      <!-- 编辑弹窗 -->
      <create-form ref="createForm" @ok="getList" />

      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageBankBranch, delBankBranch, exportBankBranch, listProvinceDict, listBankIconDict } from '@/api/bank/bankBranch'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import { getToken } from '@/utils/auth'

export default {
  name: 'BankBranch',
  components: { CreateForm },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      selectedRowKeys: [],
      selectedRows: [],
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      provinceDict: [],
      bankIconDict: [],
      // 查询参数
      queryParam: {
        code: undefined,
        name: undefined,
        bankAlias: undefined,
        bankName: undefined,
        bankCode: undefined,
        bankIcon: undefined,
        cityName: undefined,
        provinceName: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        { title: this.$t('银行支行.联行号'), dataIndex: 'code', align: 'center', width: 140 },
        { title: this.$t('银行支行.清算行号'), dataIndex: 'clearingCode', align: 'center', width: 140 },
        { title: this.$t('银行支行.银行全名'), dataIndex: 'name', ellipsis: true, align: 'center' },
        { title: this.$t('银行支行.银行简称'), dataIndex: 'bankAlias', align: 'center', width: 100 },
        { title: this.$t('银行支行.银行名称'), dataIndex: 'bankName', align: 'center', width: 100 },
        { title: this.$t('银行支行.银行编码'), dataIndex: 'bankCode', align: 'center', width: 100 },
        { title: this.$t('银行支行.城市名称'), dataIndex: 'cityName', align: 'center', width: 100 },
        { title: this.$t('银行支行.省份名称'), dataIndex: 'provinceName', align: 'center', width: 100 },
        { title: this.$t('银行支行.图标'), dataIndex: 'bankIcon', align: 'center', ellipsis: true },
        { title: this.$t('银行支行.创建时间'), dataIndex: 'createTime', align: 'center', width: 170 },
        { title: this.$t('通用.文本.操作'), dataIndex: 'operation', width: 160, scopedSlots: { customRender: 'operation' }, align: 'center', fixed: 'right' }
      ]
    }
  },
  created() {
    this.getList()
    this.loadDicts()
  },
  methods: {
    getTotal(total) {
      return this.$t('通用.文本.共') + total + this.$t('通用.文本.条')
    },
    /** 加载省份、图标下拉 */
    loadDicts() {
      listProvinceDict().then((response) => {
        this.provinceDict = response.data || []
      })
      listBankIconDict().then((response) => {
        this.bankIconDict = response.data || []
      })
    },
    /** 查询列表 */
    getList() {
      this.loading = true
      pageBankBranch(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        code: undefined,
        name: undefined,
        bankAlias: undefined,
        bankName: undefined,
        bankCode: undefined,
        bankIcon: undefined,
        cityName: undefined,
        provinceName: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.selectedRowKeys = []
      this.ids = []
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = selectedRows.map((item) => item.id)
      this.multiple = !selectedRowKeys.length
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids = [row.id]
      }
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk() {
          const data = that.ids.map((id) => ({ id }))
          return delBankBranch(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success(that.$t('通用.文本.删除成功'))
          })
        },
        onCancel() {
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      const that = this
      const queryParams = { ...this.queryParam }
      delete queryParams.pageNum
      delete queryParams.pageSize
      this.$confirm({
        title: this.$t('通用.文本.确认导出所有数据'),
        onOk() {
          return exportBankBranch(queryParams).then((response) => {
            const blob = new Blob([response])
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = '银行支行数据.xls'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            that.$message.success(that.$t('通用.文本.导出成功'))
          })
        }
      })
    }
  }
}
</script>